import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import ServiceCleanWaterBores from '../../components/ServiceCleanWaterBores'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'


const ServiceCleanWaterBoresPage =() => {
    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Service'} pagesub={'Service'}/>
            <ServiceCleanWaterBores/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ServiceCleanWaterBoresPage;
